<template>
    <div class="count"><span class="sum">{{ count }}</span>Follows</div>
</template>

<script>

import { VueStorage } from 'vue2-storage'
import { formatCount } from '@/library/GlobalHelper.js'

export default {
  name: 'FanCountInstagram',
  data () {
    return {
      count: '',
      timenow: new Date().getTime()
    }
  },
  mounted () {
    let social_ig = localStorage.getItem('social_ig')

    if (social_ig) {
      let igCount = JSON.parse(social_ig)

      if ((this.timenow - igCount.lastupdate) > ((48 * 60 * 60) * 1000)) {
        this.fetchSocialCount()
      } else {
        this.count = formatCount(igCount.ig)
      }
    } else {
      this.fetchSocialCount()
    }
  },
  methods: {

    fetchSocialCount () {
      fetch(window._social_count).then(res => {
        return res.json()
      }).then(data => {
        let args = {
          'ig': data.ig,
          'lastupdate': this.timenow
        }
        localStorage.setItem('social_ig', JSON.stringify(args))
        this.count = formatCount(data.ig)
      })
    }

  }
}
</script>
